import $ from "jquery";

import React, { Component } from "react";
import { connect } from "react-redux";
import { formValueSelector, Field, Fields, change } from "redux-form";
import Loading from "components/Loading";
import { Column, Row } from "react-foundation";

import { getDoorOptions, addPreviousPreviews, loadWhiteFrame } from "actions";
import ChipsGrid from "components/ChipsGrid";

import colourSwapperIn from "images/icon-flip-door-front-to-back.svg";
import colourSwapperOut from "images/icon-flip-door-back-to-front.svg";
import ImageResolver from "./../../ImageResolver";
import InputError from "../../../components/InputError";
import ThemeButton from "../../../components/ThemeButton";
import SeparatingLine from "../../../components/SeparatingLine";
import { getCompositeDoorColours } from "./../../../selectors";
import FormHeader from "../../../components/FormHeader";
import FormWrapper from "../../FormWrapper";
import { updatePreviousSelection } from '../../../actions';

const SelectColour = ({ colours, input }) => {
    if ($.isEmptyObject(colours)) {
        return <Loading />;
    }

    return (
        <div>
            <Row isColumn>
                <ChipsGrid
                    colours={colours}
                    selectedId={input.value}
                    onChange={input.onChange} />
            </Row>
        </div>
    );
};

const SelectColours = ({ selected, interiorColours, exteriorColours, DoorInteriorColourId, DoorExteriorColourId }) => {
    return (
        <div>
            <Row
                isColumn
                style={{
                    display: selected === "interior"
                        ? "block"
                        : "none"
                }}>
                <Field
                    name="DoorInteriorColourId"
                    component={SelectColour}
                    colours={interiorColours}
                    key={selected} />
            </Row>

            <Row
                isColumn
                style={{
                    display: selected === "exterior"
                        ? "block"
                        : "none"
                }}>
                <Field
                    name="DoorExteriorColourId"
                    component={SelectColour}
                    colours={exteriorColours}
                    key={selected} />
            </Row>

            <InputError metas={[DoorExteriorColourId.meta, DoorInteriorColourId.meta]} />
        </div>
    );
};

class ColourForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: "exterior"
        };
    }

    componentDidMount() {
        // let itemTypeId = 2; // door

        this.props.getDoorOptions(this.props.doorTypeId, this.props.doorRoomId);

        if(!this.props.doorFrameId)
            this.props.loadWhiteFrame(this.props.doorTypeId);
    }

    componentDidUpdate() {

        let { selectedColours, interiorColours, exteriorColours, dispatch, previousSelection } = this.props;

        if (!selectedColours.interior.id) {
            if (interiorColours.length > 0) {
                dispatch(change("DoorWizard", "DoorInteriorColourId", previousSelection.DoorCompositeColourInteriorId || interiorColours[0].id));
            }
        }

        if (!selectedColours.exterior.id) {
            if (exteriorColours.length > 0) {
                dispatch(change("DoorWizard", "DoorExteriorColourId", previousSelection.DoorCompositeColourExteriorId || exteriorColours[0].id));
            }
        }
    }

    onSubmit(values) {



        this.props.updatePreviousSelection({
            DoorCompositeColourInteriorId: values.DoorInteriorColourId,
            DoorCompositeColourExteriorId: values.DoorExteriorColourId
        });

        this.props.addPreviousPreviews({
            slabExtraId: this.props.selectedColours.exterior.id
        }, [1, 4], this.props.onSubmit);
    }

    render() {
        let { interiorColours, exteriorColours, selectedColours } = this.props;

        return (
            <form
                className="ColourForm"
                onSubmit={this.props.handleSubmit(this.onSubmit.bind(this))}>
                <FormHeader
                    title={"Colours"}
                    subtitle={"Make your home stand out with our range of coloured options."} />

                <SeparatingLine />

                <FormWrapper>
                    <Row collapseOnSmall uncollapseOnMedium>
                        <Column pushOnLarge={6} large={6}>
                            <Row>
                                <Column offsetOnSmall={2} small={8}>
                                    <div
                                        className={"flippable-door" + (this.state.selected === "interior"
                                            ? " flipped"
                                            : "")}>
                                        <div className="exterior">
                                            <ImageResolver
                                                query={{
                                                    productId: this.props.doorTypeId,
                                                    styleId: this.props.doorStyleId
                                                }}
                                                filters={[{
                                                    slabExtraId: selectedColours.exterior.id
                                                }
                                                ]}
                                                useLoadingFeature={true} />
                                        </div>
                                        <div className="interior">
                                            <ImageResolver
                                                filters={[{
                                                    slabExtraId: selectedColours.interior.id
                                                }
                                                ]}
                                                useLoadingFeature={true} />
                                        </div>
                                    </div>
                                </Column>
                                <Column small={2}>
                                    {this.state.selected === "exterior" && (<img
                                        onClick={() => this.setState({ selected: "interior" })}
                                        src={colourSwapperIn}
                                        alt=""
                                        className="swapper-button" />)}
                                    {this.state.selected === "interior" && (<img
                                        onClick={() => this.setState({ selected: "exterior" })}
                                        src={colourSwapperOut}
                                        alt=""
                                        className="swapper-button" />)}
                                </Column>
                            </Row>
                        </Column>
                        <Column
                            pullOnLarge={7}
                            large={5}
                            style={{
                                paddingTop: 10
                            }}>
                            <Row hideOnlyFor={"small"}>
                                <Column small={12}>
                                    <span
                                        className={"colour-type-label" + (this.state.selected === "exterior"
                                            ? " selected"
                                            : "")}
                                        onClick={() => this.setState({ selected: "exterior" })}>
                                        Exterior
                                    </span>
                                    <span
                                        className={"colour-type-label" + (this.state.selected === "interior"
                                            ? " selected"
                                            : "")}
                                        onClick={() => this.setState({ selected: "interior" })}>
                                        Interior
                                    </span>
                                </Column>
                            </Row>

                            <Fields
                                names={["DoorInteriorColourId", "DoorExteriorColourId"]}
                                selected={this.state.selected}
                                interiorColours={interiorColours}
                                exteriorColours={exteriorColours}
                                component={SelectColours} />
                        </Column>
                    </Row>
                </FormWrapper>

                <div className="button-panel">
                    <SeparatingLine />
                    <button className="button back" type="button" onClick={this.props.previousPage}>
                        Back
                    </button>
                    <ThemeButton className="next">Next</ThemeButton>
                </div>
            </form>
        );
    }
}

const mapStateToProps = state => {
    let valueSelector = formValueSelector("DoorWizard");
    let doorTypeId = valueSelector(state, "DoorTypeId");
    let doorRoomId = valueSelector(state, "DoorRoomId");
    let doorStyleId = valueSelector(state, "DoorStyleId");
    let doorFrameId = valueSelector(state, "DoorFrameId");

    let interiorColourId = valueSelector(state, "DoorInteriorColourId");
    let exteriorColourId = valueSelector(state, "DoorExteriorColourId");

    let interiorColours = getCompositeDoorColours(state, "internal");
    let exteriorColours = getCompositeDoorColours(state, "external");

    let selectedColours = {
        interior: interiorColours.filter(c => c.id === interiorColourId)[0] || {},
        exterior: exteriorColours.filter(c => c.id === exteriorColourId)[0] || {}
    };

    return {
        interiorColours,
        exteriorColours,
        selectedColours,
        doorTypeId,
        doorStyleId,
        doorRoomId,
        doorFrameId,
        previousSelection: state.PreviousSelection
    };
};

export default connect(mapStateToProps, { getDoorOptions, addPreviousPreviews, updatePreviousSelection, loadWhiteFrame })(ColourForm);



// WEBPACK FOOTER //
// ./src/containers/DoorForm/composite/ColourForm.js